import { Fragment } from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from './styles';
import PropTypes from 'prop-types';
import { Buffer } from 'buffer';
import logger from 'utils/logger';
import { KEY_LABELS, getValueFromLabel, LABELS } from './constants';

const log = logger.createLogger('ReportKeyImages');

const propTypes = {
  reportContent: PropTypes.object.isRequired,
};

const ReportKeyImages = ({ reportContent }) => {
  const { content } = reportContent;

  const keyImages = getValueFromLabel(content, KEY_LABELS[LABELS.KEY_IMAGES]);

  return (
    <Fragment>
      <View style={styles.reportSectionTitle}>
        <Text>{intl.get(KEY_LABELS[LABELS.KEY_IMAGES])}</Text>
      </View>
      <View style={styles.reportSectionContent}>
        {keyImages.map((item, index) => {
          let imageSrc;
          try {
            // Try using Buffer if available
            imageSrc = Buffer.from(item.fileBuffer);
          } catch (error) {
            log.error('Error in ReportKeyImages', error);
            // Fallback: if fileBuffer is already a Uint8Array, use it directly
            if (item.fileBuffer instanceof Uint8Array) {
              imageSrc = item.fileBuffer;
            } else {
              return null; // Skip this image
            }
          }

          return <Image key={index} style={styles.keyImage} src={imageSrc} />;
        })}
      </View>
    </Fragment>
  );
};

ReportKeyImages.propTypes = propTypes;

export default ReportKeyImages;
